/**
 * CF-GROWTH-V1 — which BUILD VARIANTS may surface the growth features.
 *
 * CF-POT-COUNTER-REMOVE-V1 (PL TG #12916): there were originally TWO growth surfaces with two
 * different build-gate answers. The PotCounter (a BONUS-programme surface, gated by the existing
 * Scorer-ratified `BONUS_AVAILABLE_IN_BUILD` in lib/bonus-availability.ts) has been removed from the
 * app. That gate constant is unchanged and still used by every other bonus surface; it simply no
 * longer has a growth consumer. This module now gates exactly one surface:
 *
 *  - WinsTicker is a NEW surface (de-identified recent-win social proof) whose regulatory status on
 *    the German build is not yet ruled. This module is that gate, and it FAILS CLOSED: the German
 *    variant is excluded by default until PL/Scorer explicitly rule whether Münzo may show a wins
 *    ticker. This is a conservative default that MIRRORS the bonus-availability pattern; it is NOT
 *    a citation of German law as a blocker (the CF entity's legal posture is PL-ruled elsewhere).
 *    Flipping this to include German is a one-line change that requires that ruling plus reviewed
 *    German ticker wording — exactly like inverting the bonus gate.
 *
 * The pure predicate is kept separate from the module-load constant so a test can reason about a
 * variant other than the one it was built as, without rebuilding under four env vars.
 */
import { isGerman } from './app-variant.ts';

/** True when this build may surface the de-identified wins ticker. Fail-closed on German. */
export const WINS_TICKER_AVAILABLE_IN_BUILD: boolean = !isGerman;

/** Pure form, for tests and cross-variant reasoning. */
export function winsTickerAvailableForVariant(variant: string): boolean {
    return variant !== 'german';
}
